import { useState, useEffect, useCallback } from 'react';

const BASE  = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const token = () => localStorage.getItem('kialuga_token');

export async function apiFetch(endpoint, method='GET', body=null) {
  const opts = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token() && { Authorization: `Bearer ${token()}` }),
    },
  };
  if (body && !(body instanceof FormData)) {
    opts.body = JSON.stringify(body);
  } else if (body instanceof FormData) {
    delete opts.headers['Content-Type'];
    opts.body = body;
  }
  const res  = await fetch(`${BASE}${endpoint}`, opts);
  const data = await res.json();
  if (!res.ok) throw new Error(data.mensagem || `Erro ${res.status}`);
  return data;
}

export function useApi(endpoint, deps=[]) {
  const [dados,      setDados]      = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro,       setErro]       = useState(null);

  const carregar = useCallback(async () => {
    if (!endpoint) return;
    setCarregando(true); setErro(null);
    try { setDados(await apiFetch(endpoint)); }
    catch(e) { setErro(e.message); }
    finally { setCarregando(false); }
  }, [endpoint, ...deps]);

  useEffect(() => { carregar(); }, [carregar]);
  return { dados, carregando, erro, recarregar: carregar };
}
